import { Navigate } from "react-router-dom";
import ErrorPage from "../components/errorPage/errorPage";
import Analytics from "../pages/analytics/analytics";
import Profile from "../pages/settings/profile/profile";
import Security from "../pages/settings/security/security";
import Settings from "../pages/settings/settings";
import ExternalWorklists from "../pages/worklists/externalWorklists";
import FinalWorklist from "../pages/worklists/finalWorklist/finalWorklist";

export const LegacyExternalWorklistRouteConfig = [
  { index: true, element: <ExternalWorklists /> },
  {
    path: "external-worklist",
    element: <ExternalWorklists />,
    children: [
      { index: true, element: <Navigate to="final-worklist" replace /> },
      { path: "final-worklist", element: <FinalWorklist /> },
    ],
  },
  {
    path: "external-analytics",
    element: <Analytics />,
  },
  {
    path: "settings",
    element: <Settings />,
    children: [
      { index: true, element: <Navigate to="profile" replace /> },
      { path: "profile", element: <Profile /> },
      { path: "security", element: <Security /> },
    ],
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
];
